@if ($controlPoints(); as controlPoints) {
    <cm-rgb-curves
        [width]="$width()"
        [height]="$height()"
        [controlPoints]="controlPoints"
        (onControlPointAdded)="addControlPoint($event.curve, $event.point)"
        (onControlPointRemoved)="removeControlPoint($event.curve, $event.pointId)"
        (onControlPointChanged)="changeControlPoint($event.curve, $event.pointId, $event.point)"
    ></cm-rgb-curves>
}
